import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { NgFor, NgClass } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReviewService } from './../review.service'; // Import Review Interface

@Component({
  selector: 'app-review',
  standalone: true,
  imports: [MatIconModule,CommonModule, FormsModule,MatButtonModule,  MatFormFieldModule,  MatInputModule],
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.css']
})
export class ReviewComponent {
  constructor(public dialogRef: MatDialogRef<ReviewComponent>, private reviewService: ReviewService) {}
  reviews: { userName: string; content: string;Page: string; rating: number }[] = [];
  newReview = { userName: '', content: '', Page: '', rating: 0 };

  // Set selected rating
  setRating(stars: number): void {
    this.newReview.rating = stars;
  }
  onClose(): void {
    this.dialogRef.close();
  }
  submitReview(): void {
    if (this.newReview.rating === 0) {
      alert('Please select a star rating.');
      return;
    }
    if (this.newReview.userName.trim() === '' || this.newReview.content.trim() === '') {
      alert('Please enter your name and review.');
      return;
    }

    this.reviewService.addReview(this.newReview).subscribe({
      next: (response) => {
        this.reviews.push(response);
        this.newReview = { userName: '', content: '', Page: '', rating: 0 }; // Reset form
        alert('Thanks for sharing your thoughts! Your feedback helps us improve.'); // Show success message
        this.dialogRef.close(); // Close modal after submission
      },
      error: (err) => {
        console.error('Error adding review:', err);
        alert('Failed to submit review. Please try again.');
      }
    });
  }
  
}
